let paginationEl, articleIndexGridEl, loadingSpinner

document.addEventListener('facetwp-loaded', function () {
  paginationEl = document.querySelector('.facetwp-pager')
  articleIndexGridEl = document.querySelector('.article-index-grid')

  if(!loadingSpinner) {
    loadingSpinner = document.createElement('div')
    loadingSpinner.className = 'articles-loading-icon'

    articleIndexGridEl.prepend(loadingSpinner)
  }

  if (paginationEl.children.length > 0) {
    paginationEl.classList.add('has-border')
  }

  else {
    paginationEl.classList.remove('has-border')
  }

  articleIndexGridEl.classList.remove('loading')

  if(articleIndexGridEl) {
    // Scroll to top of article index when page changes
    if (FWP.enable_scroll === true) {
      window.scrollTo(window.scrollX, articleIndexGridEl.offsetTop)
    }
  }

})

// From https://facetwp.com/help-center/facets/facet-types/pager/#how-to-add-pagination-scrolling
document.addEventListener('facetwp-refresh', function () {
  if (FWP.soft_refresh === true) {
    FWP.enable_scroll = true
  }

  else {
    FWP.enable_scroll = false
  }

  if ( FWP.loaded ) {
    articleIndexGridEl.classList.add('loading')
  }
})